import { BrgButton, ButtonVariant, FlexBox, useToasts } from "@brg/ui";
import { CurrencyType } from "@brg/api";
import { FC } from "react";
import styled from "styled-components";
import { LayoutConst, useModal } from "../../../core";
import { useDispatch, useSelector } from "react-redux";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import { clearOrderFields, selectorOrder, setImmediatePurchaseProps } from "../../features/QueuePaymenrt/slices/OrderSlice";
import { EntityPaymentTypes } from "../../features/QueuePaymenrt/constants/payment";
import { FlowType } from "../../features/QueuePaymenrt/constants/flowType";
import { useTranslation } from "react-i18next";
import urlApi from "../../actions/urlApi";

const Wrapper = styled(FlexBox)`
    width: 560px;
    background: #fefefe;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 32px 40px 40px 40px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 16px;
        width: 300px;
    }
`;

const Title = styled.div`
    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: -0.02em;
    color: #151514;
    margin-bottom: 8px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: normal;
    }
`;

const Content = styled(FlexBox)`
    margin-bottom: 24px;
`;

const InfoText = styled.div`
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

const ButtonContainer = styled(FlexBox)`
    flex-flow: row;
    gap: 16px;
    width: 100%;
`;

const ActionButton = styled(BrgButton)`
    flex: 1;
    font-weight: 600;
`;

const CloseWrapper = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    z-index: 1;

    @media (max-width: ${LayoutConst.screen.s}px) {
        top: 12px;
        right: 12px;
    }
`;

interface CourseCardPurchaseModalProps {
    productId?: string;
}

export const CourseCardPurchaseModal: FC<CourseCardPurchaseModalProps> = ({ productId = "" }) => {
    const modal = useModal();
    const dispatch = useDispatch();
    const toasts = useToasts();
    const { t } = useTranslation();
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError, immediatePurchaseProps, bookCard, bookCardT } = useSelector(selectorOrder)

    const handleCancel = () => {
        modal.hide();
    };

    const isOnEducationDomain = (): boolean => {
        const educationUrl = process.env.REACT_APP_URL_MEDIIIA_COM;
        if (!educationUrl) return true;
        try {
            return window.location.hostname === new URL(educationUrl).hostname;
        } catch {
            return false;
        }
    };

    const handleConfirm = async () => {
        if (!productId) {
            toasts.error(t("course_card_purchase_modal.errors.product_id_not_found"));
            return;
        }

        if (!isOnEducationDomain()) {
            modal.hide();
            const educationUrl = process.env.REACT_APP_URL_MEDIIIA_COM!;
            window.location.href = educationUrl + window.location.pathname + window.location.search;
            return;
        }

        try {
            const cardResponse = await urlApi().getCard(productId);
            const card = await cardResponse?.json();
            console.log('card', card)
            const cardPrice =
                Number(card?.priceInfo?.realProductPrice) ||
                Number(card?.realProductPrice) ||
                Number(card?.price) ||
                0;
            const cardName = Array.isArray(card?.name)
                ? card.name.find((item: any) => item?.lang?.toLowerCase() === "ru")?.name || card.name[0]?.name
                : card?.name;
            const cardPreview = Array.isArray(card?.images) ? card.images : [];

            dispatch(clearOrderFields());
            dispatch(setImmediatePurchaseProps({
                productId,
                paymentEntityType: EntityPaymentTypes.course,
                flowType: FlowType.COPY_CARD,
                currencyType: CurrencyType.RUB,
                tariff: activeTariff,
                price: cardPrice,
                productInfo: {
                    id: productId,
                    name: cardName || t("course_card_purchase_modal.product_name"),
                    preview: cardPreview,
                    type: EntityPaymentTypes.course,
                    typeCard: "product",
                    summary: {}
                }
            }));

            modal.hide();
            modal.show("paymentManager", {
                containerStyles: {
                    background: "rgba(231,231,231,1)",
                    backdropFilter: "none"
                },
                flowType: FlowType.COPY_CARD,
                cancel: () => {
                    dispatch(clearOrderFields());
                }
            });
        } catch (error) {
            toasts.error(t("course_card_purchase_modal.errors.product_id_not_found"));
        }
    };

    return (
        <Wrapper>
            <CloseWrapper>
                <IconCloseMob onClick={handleCancel} />
            </CloseWrapper>
            <Title>{t("course_card_purchase_modal.title")}</Title>
            <Content gy={4} direction="column">
                <InfoText>
                    {isOnEducationDomain()
                        ? t("course_card_purchase_modal.description")
                        : t("course_card_purchase_modal.redirect_to_education")}
                </InfoText>
            </Content>
            <ButtonContainer>
                <ActionButton variant={ButtonVariant.Hollow} onClick={handleCancel}>
                    {t("course_card_purchase_modal.cancel")}
                </ActionButton>
                <ActionButton variant={ButtonVariant.Filled} onClick={handleConfirm}>
                    {t("course_card_purchase_modal.confirm")}
                </ActionButton>
            </ButtonContainer>
        </Wrapper>
    );
};
import { BrgButton, ButtonVariant, FlexBox, useToasts } from "@brg/ui";
import { CurrencyType } from "@brg/api";
import { FC } from "react";
import styled from "styled-components";
import { LayoutConst, useModal } from "../../../core";
import { useDispatch, useSelector } from "react-redux";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import { clearOrderFields, selectorOrder, setImmediatePurchaseProps } from "../../features/QueuePaymenrt/slices/OrderSlice";
import { EntityPaymentTypes } from "../../features/QueuePaymenrt/constants/payment";
import { FlowType } from "../../features/QueuePaymenrt/constants/flowType";
import { useTranslation } from "react-i18next";
import urlApi from "../../actions/urlApi";

const Wrapper = styled(FlexBox)`
    width: 560px;
    background: #fefefe;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 32px 40px 40px 40px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 16px;
        width: 300px;
    }
`;

const Title = styled.div`
    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: -0.02em;
    color: #151514;
    margin-bottom: 8px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: normal;
    }
`;

const Content = styled(FlexBox)`
    margin-bottom: 24px;
`;

const InfoText = styled.div`
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

const ButtonContainer = styled(FlexBox)`
    flex-flow: row;
    gap: 16px;
    width: 100%;
`;

const ActionButton = styled(BrgButton)`
    flex: 1;
    font-weight: 600;
`;

const CloseWrapper = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    z-index: 1;

    @media (max-width: ${LayoutConst.screen.s}px) {
        top: 12px;
        right: 12px;
    }
`;

interface CourseCardPurchaseModalProps {
    productId?: string;
}

export const CourseCardPurchaseModal: FC<CourseCardPurchaseModalProps> = ({ productId = "" }) => {
    const modal = useModal();
    const dispatch = useDispatch();
    const toasts = useToasts();
    const { t } = useTranslation();
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError, immediatePurchaseProps, bookCard, bookCardT } = useSelector(selectorOrder)

    const handleCancel = () => {
        modal.hide();
    };

    const isOnEducationDomain = (): boolean => {
        const educationUrl = process.env.REACT_APP_URL_MEDIIIA_COM;
        if (!educationUrl) return true;
        try {
            return window.location.hostname === new URL(educationUrl).hostname;
        } catch {
            return false;
        }
    };

    const handleConfirm = async () => {
        if (!productId) {
            toasts.error(t("course_card_purchase_modal.errors.product_id_not_found"));
            return;
        }

        if (!isOnEducationDomain()) {
            modal.hide();
            const educationUrl = process.env.REACT_APP_URL_MEDIIIA_COM!;
            window.location.href = educationUrl + window.location.pathname + window.location.search;
            return;
        }

        try {
            const cardResponse = await urlApi().getCard(productId);
            const card = await cardResponse?.json();
            console.log('card', card)
            const cardPrice =
                Number(card?.priceInfo?.realProductPrice) ||
                Number(card?.realProductPrice) ||
                Number(card?.price) ||
                0;
            const cardName = Array.isArray(card?.name)
                ? card.name.find((item: any) => item?.lang?.toLowerCase() === "ru")?.name || card.name[0]?.name
                : card?.name;
            const cardPreview = Array.isArray(card?.images) ? card.images : [];

            dispatch(clearOrderFields());
            dispatch(setImmediatePurchaseProps({
                productId,
                paymentEntityType: EntityPaymentTypes.course,
                flowType: FlowType.COPY_CARD,
                currencyType: CurrencyType.RUB,
                tariff: activeTariff,
                price: cardPrice,
                productInfo: {
                    id: productId,
                    name: cardName || t("course_card_purchase_modal.product_name"),
                    preview: cardPreview,
                    type: EntityPaymentTypes.course,
                    typeCard: "product",
                    summary: {}
                }
            }));

            modal.hide();
            modal.show("paymentManager", {
                containerStyles: {
                    background: "rgba(231,231,231,1)",
                    backdropFilter: "none"
                },
                flowType: FlowType.COPY_CARD,
                cancel: () => {
                    dispatch(clearOrderFields());
                }
            });
        } catch (error) {
            toasts.error(t("course_card_purchase_modal.errors.product_id_not_found"));
        }
    };

    return (
        <Wrapper>
            <CloseWrapper>
                <IconCloseMob onClick={handleCancel} />
            </CloseWrapper>
            <Title>{t("course_card_purchase_modal.title")}</Title>
            <Content gy={4} direction="column">
                <InfoText>
                    {isOnEducationDomain()
                        ? t("course_card_purchase_modal.description")
                        : t("course_card_purchase_modal.redirect_to_education")}
                </InfoText>
            </Content>
            <ButtonContainer>
                <ActionButton variant={ButtonVariant.Hollow} onClick={handleCancel}>
                    {t("course_card_purchase_modal.cancel")}
                </ActionButton>
                <ActionButton variant={ButtonVariant.Filled} onClick={handleConfirm}>
                    {t("course_card_purchase_modal.confirm")}
                </ActionButton>
            </ButtonContainer>
        </Wrapper>
    );
};
